declare global {
  interface Window {
    _paq?: {
      push: (event: Array<string | number | boolean>) => void;
    };
  }
}

export const pushToMatomoIfPossible = (matomoPushObject: Array<string | number | boolean>): void => {
  if (typeof window._paq === "undefined") {
    return
  }
  window._paq.push(matomoPushObject);
}

/*
Logs an event to Matomo Analytics if it Matomo Analytics is installed on the page
@param category The category or context for the event. For components, use "URC-<component_name>"
@param actionDescription Description of the action taken
@param name The name for event. For components, use "<analyticsId>" (unique, site-wide id for component instance)
@param value The value for {@link name}, optional
*/
export const logUserEvent = (category: string, actionDescription: string, name: string, value: number | undefined = undefined): void => {
  const event: Array<string | number | boolean> = ["trackEvent", category, actionDescription, name];
  if (value) {
      event.push(value)
  }
  pushToMatomoIfPossible(event);
};
